import { BusinessOrdersStatusKpi } from '@/models/kpis/business-orders-status-kpi';
import { BusinessInteractionStatusKpi } from '@/models/kpis/business-interactions-status-kpi';
import { axiosService } from '.';

export default class KpisService {
    public async getBusinessStatusKpi(businessId: number): Promise<GetBusinessStatusKpiOutputDto> {
        const response = await axiosService.instance.get(`kpis/organization/business-status/${businessId}`);
        return response.data;
    }

    public async getBusinessProductsStatusKpi(businessId: number): Promise<GetBusinessProductsStatusKpiOutputDto> {
        const response = await axiosService.instance.get(`kpis/organization/business-products-status/${businessId}`);
        return response.data;
    }

    public async getBusinessOrdersStatusKpi(businessId: number): Promise<BusinessOrdersStatusKpi> {
        return new BusinessOrdersStatusKpi((await axiosService.instance.get(`kpis/organization/business-orders-status/${businessId}`)).data);
    }

    public async getBusinessInteractionStatusKpi(businessId: number): Promise<BusinessInteractionStatusKpi> {
        return new BusinessInteractionStatusKpi((await axiosService.instance.get(`kpis/organization/business-visits-status/${businessId}`)).data);
    }

    public async getBusinessServicesStatusKpi(businessId: number): Promise<GetBusinessServicesStatusKpiOutputDto> {
        const response = await axiosService.instance.get(`kpis/organization/business-services-status/${businessId}`);
        return response.data;
    }

    public async getBusinessBookingsStatusKpi(businessId: number): Promise<GetBusinessBookingsStatusKpiOutputDto> {
        const response = await axiosService.instance.get(`kpis/organization/business-bookings-status/${businessId}`);
        return response.data;
    }
}

export const kpisService = new KpisService();

export class GetBusinessStatusKpiOutputDto {
    public readonly isPublished: boolean = false;
    public readonly hasSlug: boolean = false;
    public readonly hasSaleEnabled: boolean = false;
    public readonly hasConfiguredPaymentMethods: boolean = false;
    public readonly hasConfiguredDeliveryMethod: boolean = false;
    public readonly hasBookingRequestsEnabled: boolean = false;

    public hasConfiguredStore(): boolean {
        return this.hasSaleEnabled && this.hasConfiguredPaymentMethods && this.hasConfiguredDeliveryMethod;
    }
}

export class GetBusinessServicesStatusKpiOutputDto {
    public readonly totalServicesCount: number = 0;
    public readonly totalPublishedServicesCount: number = 0;
    public readonly totalAvailableServicesCount: number = 0;
}

export class GetBusinessBookingsStatusKpiOutputDto {
    public readonly totalBookingRequestsCount: number = 0;
}

export class GetBusinessProductsStatusKpiOutputDto {
    public readonly totalProductsCount: number = 0;
    public readonly totalPublishedProductsCount: number = 0;
    public readonly totalAvailableProductsCount: number = 0;
    public readonly totalDiscountedProductsCount: number = 0;
    public readonly totalProductsWithoutStockCount: number = 0;
}
